import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=072a228a&scoped=true"
var script = {}
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=072a228a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a228a",
  null
  
)

export default component.exports